import { LocationDetails } from "../schemas/Search/Search.schema";
import { GeoService } from "../services/GeoService";

export const getLocationDetails = (
  location: GeoService.SinglesearchLocation
): LocationDetails => {
  const { Lat, Lon } = location.Coords || {};
  const { City, Country, State, Zip } = location.Address || {};
  const { TimeZone } = location;

  const city: any = {
    cityName: City ? City + (State ? `, ${State}` : "") : "",
    country: Country || "",
    postalCode: Zip || "",
    coords: {
      lat: Lat || "",
      lng: Lon || ""
    },
    timeZone: TimeZone
  };
  return city;
};

// to remove dulicate values from the given array
export const removeDuplicates = (myArr: any, prop: any) => {
  if (myArr.length) {
    return myArr.filter((obj: any, pos: number, arr: any) => {
      return (
        arr.map((mapObj: any) => mapObj[prop]).indexOf(obj[prop].trim()) === pos
      );
    });
  }
  return [];
};
